




































































































































































import employerDocuments from "~/mixins/employerDocuments";
import handlesJobExpiryDate from '~/mixins/handlesJobExpiryDate';

export default {
	name: 'JobsListItem',

	mixins: [
		employerDocuments,
		handlesJobExpiryDate,
	],

	props: {
		job: {
			required: true,
			type: Object,
		},
		active: {
			default: false,
			required: false,
			type: Boolean,
		},
		sidebar: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	computed: {
		scrollPosition() {
			return this.$refs.jobItem.offsetTop;
		},
		salaryFrom() {
			return this.formatSalary(this.job.salary_from);
		},
		salaryTo() {
			return this.formatSalary(this.job.salary_to);
		},
	},

	methods: {
		async toggleFavourite(e) {
			e.stopPropagation();
			await this.$store.dispatch('jobs/single/toggleFavourite', this.job);
		},

		async goToJob() {
			this.$emit('click');

			if (this.$route.params.id) {
				await this.$router.push(
					this.localePath({ path: `/jobs/${this.job.uuid}` }),
				);
			} else {
				await this.$router.push(
					this.localePath({ path: 'jobs/' + this.job.uuid }),
				);
			}
		},

		formatSalary(value) {
			if (!value) return null;
			const formatted = Intl.NumberFormat('en', {
				notation: 'compact',
				maximumFractionDigits: 2,
				minimumFractionDigits: 2,
			}).format(value);
			//Remove .00 on whole numbers
			const compact = formatted.replace('.00', '');

			//Remove the extra 0 at end if it still exists when a decimal is present
			return compact.includes('.')
				? compact.replace('0K', 'K').replace('0M', 'M')
				: compact;
		},

		trackApplyButtonEvent() {
			this.$gtm.push({
				event: 'applyButton',
				job_id: this.job.uuid,
				user_id: this.$auth.user.uuid,
				job_title: this.job.title,
				application_link: this.job.application_url,
			});
		},

		confirmApply(){
			this.$modal.show({
				type: 'info',
				title: 'Apply outside of Gradlinc',
				body: 'You are about to be redirected outside of Gradlinc to apply for this job. Do you want to continue?',
				primary: {
					label: 'Yes',
					theme: 'indigo',
					action: () => {
						this.trackApplyButtonEvent();
						let url = this.job.application_url;
						if(!url.includes('https') && !url.includes('http')){
							url = `https://${url}`;
						}
						window.open(url, '_blank');

						this.$router.push(
							this.localePath({ path: `/jobs/${this.job.uuid}` }),
						);
					},
				},
				secondary: {
					label: this.$t('cancel'),
					theme: 'white',
					action: () => ({}),
				},
			});
		},
	},
};
